.popover {
  position: fixed;
  z-index: 100100; /* acima dos modais/overlays, inclusive o filtro de periodo */
  background: var(--card);
  border: 1px solid var(--stroke);
  border-radius: var(--radius-sm);
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.28);
  overflow: hidden;
}
